import axiosInstance from "../../../util/axiosInstance";
import { selectInvitationTemplates } from "../../../util/invitationTemplateCatalog";

export const fetchinvitationtemplates = async (eventCategoryName, eventName, screenType) => {
  try {
    const response = await axiosInstance.get(`/templates-bg/list?platform=${screenType}`);
    return selectInvitationTemplates(response.data.data, eventCategoryName, eventName);
  } catch (error) {
    console.warn("Error fetching invitation templates:", error);
    return null;
  }
};

export const fetchInvitationTemplateWithPng = async (
  eventCategoryName,
  eventName,
  screenType,
  png,
) => {
  console.log(
    "fetchInvitationTemplateWithPng",
    eventCategoryName,
    eventName,
    screenType,
    png,
  );
  const baseData = await fetchinvitationtemplates(
    eventCategoryName,
    eventName,
    screenType,
  );
  console.log("Image list", baseData);
  if (!baseData) return null;

  if (png) {
    const matched = baseData.images.find((img) => img.name === png);
    if (matched) {
      console.log("Matched image found:", matched);
      return {
        ...baseData,
        images: [matched], // return only the matched image
      };
    }
  }

  return baseData;
};

export const getinvitation_templates_by_category = async (url) => {
  console.log("url123", url);

  try {
    const response = await axiosInstance.get(url, { responseType: "blob" });
    let data = response?.data;
    console.log("got api response", response);
    if (!data) return null;

    // Ensure we have a real Blob
    if (!(data instanceof Blob)) {
      // Some dev servers wrap Blob in { data: Blob }, extract it
      if (data.data && data.data instanceof Blob) {
        data = data.data;
      } else {
        console.warn("Not a real Blob", data);
        return null;
      }
    }

    // Check if the Blob is an image
    if (!data.type.startsWith("image/")) {
      const text = await data.text().catch(() => "");
      console.warn("Blob is not an image, server said:", text || data.type);
      return null;
    }
    console.log("Image template", data);
    console.log("got valid image blob here", data);
    return data;
  } catch (error) {
    console.error("Failed to load image", error);
    return null;
  }
};
